export default __webpack_public_path__ + "media/images/thick-arrow-de3429900afda92b6cf2413cea01d735.svg";